export default __webpack_public_path__ + "static/media/homepasta.17f4d735.jpg";